var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg20Sekainokuniguni(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#515FAA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,7.3c0-2.2,0-4.4,0-6.5c-4.6-2.6-9.4,2.6-14,0C2,2.5,2,4.2,2,6c0,0.4,0,0.8,0,1.3V28h2V7.9 C8,8.5,12,5.1,16,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,15.3c0-2.2,0-4.4,0-6.5c-4.6-2.6-9.4,2.6-14,0c0,0.8,0,1.5,0,2.3c0,1.4,0,2.8,0,4.3V28h2V15.9 C14,16.5,18,13.1,22,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,16.7c0,0.8,0,1.5,0,2.3c0,1.4,0,2.8,0,4.3V28h2v-4.1c4,0.6,8-2.9,12-0.7c0-2.2,0-4.4,0-6.5 C23.4,14.2,18.6,19.3,14,16.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Sekainokuniguni);
export default __webpack_public_path__ + "static/media/20_sekainokuniguni.64d649c3c1bcdccef653d24525f9b7ee.svg";
export { ForwardRef as ReactComponent };